import React, { useState } from 'react';
import LogoHdi from '../../../../../../resources/imgs/logo-hdi.png';
import Button from '../../../../../../components/Button';
import LenderModal from '../LenderModal';

interface LenderBannerProps {
  setPause: (pause: boolean) => void;
}

const LenderBanner: React.FC<LenderBannerProps> = ({ setPause }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const handleOpenModal = () => {
    setOpenModal(true);
    setPause(true);
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img src={LogoHdi} style={{ width: '85px', height: '85px' }} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'start'
        }}
      >
        <div style={{ fontWeight: 'bold', color: '#007337', fontSize: '17px' }}>
          Seguro Prestamista
        </div>
        <div style={{ fontWeight: 'normal', fontSize: '14px' }}>
          Segurança e garantia de pagamento do aluguel em caso de imprevistos.
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button
          fluid
          type={'button'}
          size={'mini'}
          text="Saiba mais"
          style={{
            margin: '0.5em 0em',
            paddingLeft: '36px',
            paddingRight: '36px'
          }}
          onClick={() => handleOpenModal()}
        />
      </div>
      <LenderModal isOpen={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
};

export default LenderBanner;
